export default __webpack_public_path__ + "static/media/howto1.3f2626db.png";